<template>
  <div class="form-group">
    <label for="address">
      {{ label }}
    </label>
    <input
      id="autocomplete"
      disabled="disabled"
      :value="addressFormatted"
      class="form-control"
      :class="customValidation"
      placeholder="15 rue Poissonière, 75002 Paris, FRANCE"
      type="text"
      aria-autocomplete="none"
      autocomplete="off"
      @input.once="appendCustom"
    >
    <transition
      tag="div"
      @enter="tf_slideDown"
      @leave="tf_slideUp"
    >
      <div
        v-if="isAddressComplete === false"
        class="invalid-feedback"
      >
        {{ errorMessage }}
      </div>
    </transition>
    <transition
      tag="div"
      @enter="tf_slideDown"
      @leave="tf_slideUp"
    >
      <div
        v-if="customError"
        class="invalid-feedback"
      >
        {{ customErrorMessage }}
      </div>
    </transition>
    <transition
      tag="div"
      @enter="tf_slideDown"
      @leave="tf_slideUp"
    >
      <v-address
        v-if="showAddressFiller"
        class="mt-3 mb-5"
        :module-name="moduleName"
        :getter-name="getterName"
        :getter-function="getterFunction"
        :path="path"
      />
    </transition>
  </div>
</template>
<script>
import maps from '@/services/vendors/maps';

import input from '@/mixins/input-2';
import { transform } from '@/mixins';
import { validateAddress } from '@/utils/validators';

import Address from '@/components/common/input/Address.vue';

export default {
  name: 'InputPlaceTwo',
  components: {
    'v-address': Address,
  },
  mixins: [transform, input],
  props: {
    inputDisabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      getPlace: () => {},
      showAddressFiller: false,
      customError: false,
      customErrorMessage: 'Veuillez saisir manuellement votre adresse',
    };
  },
  computed: {
    addressFormatted() {
      if (this.customValue) {
        const address = Object.values(this.customValue);
        if (address.length) {
          return address.join(' ').trim();
        }
      }
      return '';
    },
    isAddressComplete() {
      return (validateAddress(this.customValue));
    },
    customValidation() {
      if (this.isAddressComplete === null) return '';
      return this.isAddressComplete === false ? 'is-invalid' : 'is-valid';
    },
    pacContainer() {
      if (document.getElementsByClassName('pac-container').length) {
        return document.getElementsByClassName('pac-container')[0];
      }
      return [];
    },
  },
  mounted() {
    this.getPlace = maps('autocomplete', this.setCustomModel, this.setError);
  },
  beforeDestroy() {
    const pac = document.getElementsByClassName('pac-container');
    if (pac.length > 0) {
      for (let i = 0; i < pac.length; i += 1) {
        const element = pac[i];
        element.remove();
      }
    }
  },
  methods: {
    setError() {
      this.showAddressFiller = true;
    },
    scrollBot() {
      const el = document.getElementById('autocomplete');
      const container = document.getElementById('modalApp');
      this.tf_scrollTo(el, container, () => {}, this.showAddressFiller ? -200 : 0);
    },
    appendCustom() {
      const elems = document.getElementsByClassName('pac-container');
      const container = document.createElement('div');
      const insideSpan = document.createElement('span');
      container.classList.add('pac-item');
      container.classList.add('order-2');
      insideSpan.classList.add('pac-item-query');
      insideSpan.classList.add('fw-bold');
      insideSpan.innerText = ('Je ne trouve pas mon adresse');
      container.appendChild(insideSpan);
      container.addEventListener('mousedown', () => {
        this.showAddressFiller = true;
      });
      if (elems) {
        for (let i = 0; i < elems.length; i += 1) {
          const element = elems[i];
          element.appendChild(container);
        }
      }
    },
  },
};
</script>
<style>
input::placeholder {
  color:rgb(175, 175, 175);
}
.pac-logo:after {
  order:3;
}
.pac-container {
  margin-top: 1em;
  z-index: 10000 !important;
  flex-direction: column;
  order: 1;
  width: 100%;
  padding: 1rem 1rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 2px solid #ced4da;
  border-radius: 8px;
  box-shadow: none;
}
.pac-item {
  border:0;
  padding: 1em 0;
}
</style>
